import {Component, computed, input} from '@angular/core';
import {TranslocoDirective, TranslocoService} from '@jsverse/transloco';
import {
  AdditionalConditionsType,
  CampaignCardSentenceMerchantComponent,
  getCampaignRemainingPercentileBudget,
  getCampaignRemainingRewards,
  openMapApp,
  Size
} from 'shared-lib';
import {NgOptimizedImage} from '@angular/common';
import {Campaign} from '../../../../../../../shared-lib/src/lib/services/model';

@Component({
  selector: 'app-limited-offer-details',
  templateUrl: './limited-offer-details.component.html',
  styleUrls: ['./limited-offer-details.component.scss'],
  imports: [
    TranslocoDirective,
    CampaignCardSentenceMerchantComponent,
    NgOptimizedImage,

  ]
})
export class LimitedOfferDetailsComponent {
  campaign = input.required<Campaign>();

  activeRewardsText = computed<string>(() => {
    if (!this.campaign().availableBudget || !this.campaign().reward || this.campaign().consumedBudget == undefined) {
      return '';
    }

    const remaining = getCampaignRemainingRewards(this.campaign());

    // TODO: Change this to monetary value check in the future
    if (this.campaign().additionalConditions?.additionalConditionsType == AdditionalConditionsType.LOYALTY) {
      return this.transloco.translate('limitedOffers.card.percentileRewardsRatio', {
        remaining: getCampaignRemainingPercentileBudget(this.campaign()),
      });
    }

    return this.transloco.translate('limitedOffers.card.rewardsRatio', {
      remaining: remaining,
    });
  });

  constructor(private transloco: TranslocoService) {
  }

  protected readonly Size = Size;
  protected readonly openMapApp = openMapApp;
  protected readonly AdditionalConditionsType = AdditionalConditionsType;
}
